export default __webpack_public_path__ + "static/media/panel-settings.3350c191.svg";